// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"e08ff995","632":"2557c631","678":"27af3973"}[chunkId] + ".chunk.js";
};